import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getConfig } from "@App/utils/getConfig";
import type { State } from "@App/state";

/**
 * FINN-specific empty state shown when no bookable garages match the filters.
 * Replaces the generic NoGarageFound box and offers a CTA back into FINN's
 * service-request flow.
 */
export function NoBookableGarage() {
  const { t } = useTranslation();
  const organization = useSelector((state: State) => state.orders.organization);
  const callbackRefToken = useSelector((state: State) => state.callbackRef.token);

  const emptyState = getConfig(organization).garageList?.emptyState;
  const ctaHref =
    callbackRefToken && emptyState?.callbackUrl
      ? `${emptyState.callbackUrl}?ref=${callbackRefToken}`
      : emptyState?.url;

  return (
    <div className="bg-white p-4 rounded">
      <div className="text-xl font-bold mb-3">{t("garageList.emptyState.headline")}</div>
      <p className="mb-4 whitespace-pre-line">{t("garageList.emptyState.description")}</p>
      <a
        href={ctaHref}
        className="inline-block bg-primary text-white px-6 py-2 rounded font-bold no-underline text-center"
      >
        {t("garageList.emptyState.finnCtaLabel")}
      </a>
    </div>
  );
}
